var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadinaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6084,
    cy: 19.5,
    r: 18.6084,
    fill: "#2F4DC4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6544_73578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5639 21.2603H23.8904V16.774C23.9066 16.2514 23.7346 15.7403 23.4056 15.334C23.2402 15.1298 23.0296 14.967 22.7904 14.8584C22.5511 14.7498 22.2899 14.6984 22.0273 14.7083H20.37L19.7274 16.1174C19.572 15.7412 19.3214 15.412 19.0002 15.162C18.6941 14.8878 18.3006 14.731 17.8897 14.7196H16.1788L15.6151 16.0441V14.7196H12.8699L12.1991 17.2869H12.8699V21.2458C12.8699 22.765 14.1015 23.9966 15.6208 23.9966V17.4024C15.6633 17.3902 15.7066 17.3808 15.7504 17.3742C15.8771 17.3408 16.0062 17.3172 16.1366 17.3038C16.2387 17.3043 16.34 17.3234 16.4353 17.3601C16.5368 17.3967 16.6319 17.449 16.7172 17.5151C16.7988 17.5784 16.8684 17.6557 16.9229 17.7434C16.9729 17.8197 17.0002 17.9086 17.0019 17.9998V21.2458C17.0019 22.765 18.2335 23.9966 19.7528 23.9966V17.4306C19.9201 17.3837 20.0921 17.3554 20.2657 17.346C20.8576 17.346 21.1508 17.5602 21.1508 17.9857V21.2598C21.1508 22.7713 22.376 23.9966 23.8875 23.9966L24.5639 21.2603ZM13.8056 11.1548H26.5849V25.3803C26.5834 25.9549 26.3546 26.5055 25.9485 26.912C25.5425 27.3185 24.9921 27.5479 24.4174 27.5502H10.1895V14.7703C10.1917 13.8121 10.5734 12.8938 11.2511 12.2162C11.9288 11.5387 12.8472 11.157 13.8056 11.1548Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6544_73578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4028,
    height: 16.486,
    fill: "white",
    transform: "translate(10.1895 11.082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadinaIcon);
export default __webpack_public_path__ + "static/media/madina_icon.f2ce5828058521364d17b7519578bf3c.svg";
export { ForwardRef as ReactComponent };